import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  OTP_FORGET_PASSWORD,
  OTP_FORGET_PASSWORD_ERROR,
  OTP_FORGET_PASSWORD_SUCCESS,
  STAFF_FORGET_PASSWORD_ERROR,
  STAFF_FORGET_PASSWORD_SUCCESS,
  STAFF_FORGET_PASSWORD,
  STAFF_OTP_FORGET_PASSWORD_ERROR,
  STAFF_OTP_FORGET_PASSWORD_SUCCESS,
  STAFF_OTP_FORGET_PASSWORD,
} from "./actionTypes";

const initialState = {
  resetToken: "",
  forgetSuccessMsg: null,
  forgetError: null,
  forgetOtpSuccessMsg: null,
};

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case STAFF_FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        forgetOtpSuccessMsg: null,
      };
      break;
    case STAFF_FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
      };
      break;
    case STAFF_FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload };
      break;
    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        forgetOtpSuccessMsg: null,
      };
      break;
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        resetToken: action.payload?.reset_token,
        forgetSuccessMsg: action.payload,
      };
      break;
    case FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload };
      break;
    case STAFF_OTP_FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        forgetOtpSuccessMsg: null,
      };
      break;
    case STAFF_OTP_FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetOtpSuccessMsg: action.payload,
      };
      break;
    case STAFF_OTP_FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload };
      break;
    case OTP_FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        forgetOtpSuccessMsg: null,
      };
      break;
    case OTP_FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetOtpSuccessMsg: action.payload,
      };
      break;
    case OTP_FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default forgetPassword;
